import React from 'react'
import CtaBlock from './CtaBlock'

type Props = {
  url: string
  buttonText: string
  downloadFileName: string
}

export default function DownloadCtaBlock({
  buttonText,
  downloadFileName,
  url,
}: Props) {
  return (
    <CtaBlock buttonText={buttonText} download={downloadFileName} url={url} />
  )
}
